import { IntlFormatters } from 'react-intl'

import { PushNotificationPayloadType } from '../state/types'

export const GlobalNotification = {
  push: () => console.log('not hooked'),
  isReady: false,
}

export const getDefaultSuccessNoti = (f?: IntlFormatters['formatMessage']) =>
  ({
    message: f
      ? f({
          id: 'notification.success',
        }) || 'Success'
      : 'Success',
    type: 'success',
  } as PushNotificationPayloadType)

export const getDefaultFailNoti = (f?: IntlFormatters['formatMessage']) =>
  ({
    message: f
      ? f({
          id: 'notification.failure',
        }) || 'Failure'
      : 'Failure',
    type: 'danger',
  } as PushNotificationPayloadType)
